import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { TabGroupState, TabsState } from '@core/constants/tabs.constants';

const initialTabsState: TabsState = {
    tabGroups: new Map(),
};

export const TabsStore = signalStore(
    { providedIn: 'root' },
    withState(initialTabsState),
    withMethods((store) => ({
        updateTabs(id: string, tabsState: any): void {
            patchState(store, (state) => ({
                tabGroups: updateTabsData(id, tabsState, state.tabGroups),
            }));
        },
        deleteAllTabs(): void {
            patchState(store, (state) => ({
                tabGroups: new Map(),
            }));
        },
    })),
);

function updateTabsData(
    id: string,
    tabGroupState: TabGroupState,
    tabGroups: Map<string, TabGroupState>,
) {
    tabGroups.set(id, {
        selectedTabHistory: tabGroupState.selectedTabHistory,
    });

    return tabGroups;
}
